import { DropdownOptionIntegerId } from '@/models/DropdownOptionIntegerId';

export class TargetObjectAttributeFilterData {
    targetObjectAttributes: Array<DropdownOptionIntegerId>;
    targetObjects: Array<DropdownOptionIntegerId>;
    dataOwners: Array<DropdownOptionIntegerId>;
}
